<template>
  <main>
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-size-10"></div>
      <div class="md-layout-item md-size-80 md-small-size-100">
        <md-card>
          <md-card-header>
            <div class="md-title">シカクマップ利用規約</div>
          </md-card-header>

          <md-card-content>
            <p class="md-body-2">第1条（規約の趣旨）</p>
            <ol class="list-style-type-decimal">
              <li>
                シカクマップ利用規約（以下、「本規約」といいます。）は、株式会社JON（以下、「JON」といいます。）が、インターネットサービス「シカクマップ」（以下、「本サービス」といいます。）を提供するにあたっての取り決めです。JONは本規約に基づき、本サービスを提供します。
              </li>
              <li>本規約は、本サービスを利用するお客様（以下、「乙」といいます。）及び乙が指定した利用者（以下、「ユーザ」といいます。）に適用します。</li>
            </ol>
            <p class="md-body-2">第2条（契約の成立）</p>
            <ol class="list-style-type-decimal">
              <li>
                乙は、本サービスの利用を希望する場合、JON所定の申込書に必要な情報を記入して、本規約に同意の上、本サービスの利用の申込みを行うものとします。JONがこれに承諾することで、申込書及び本規約の内容で、本サービスの利用を目的とする契約（以下、「本契約」といいます。）が成立するものとします。
              </li>
              <li>JONは、次の各号に該当する場合、前項の申込みを承諾しないことがあります。
                <ul class="list-style-type-decimal-bracket">
                  <li>乙が申込書に虚偽の事項を記載した場合又は記入漏れがある場合</li>
                  <li>乙が料金等の支払いを怠り又は怠るおそれがあるとJONが判断した場合</li>
                  <li>乙が違法又は公序良俗に反する利用をするおそれがあるとJONが判断した場合</li>
                  <li>乙による本サービスの利用によってJONの営利企業としての利益が実質的に損なわれるおそれがあるとJONが判断した場合</li>
                  <li>その他JONが承諾を不適当と判断する相当の理由がある場合</li>
                </ul>
              </li>
              <li>
                JONは、第1項の申込みを承諾後であっても、前項各号のいずれかに該当することが判明した場合、その承諾を取り消すことができるものとします。この場合でも、既に利用可能となった本サービスの料金は、有効に発生するものとします。
              </li>
            </ol>
            <p class="md-body-2">第3条（本サービスの開始）</p>
            <ul class="list-style-type-none">
              <li>
                本契約が成立した場合、JONは、乙に対して、本契約にかかる本サービスの内容を特定するに足る事項、本サービスの利用にかかるID及びパスワード（以下、「アカウント」といいます。）等その他必要事項を乙に通知するものとします。
              </li>
            </ul>
            <p class="md-body-2">第4条（料金の支払い）</p>
            <ul class="list-style-type-none">
              <li>乙は、申込書の記載及び次の各号に従い、本サービスの料金等を支払うものとします。</li>
              <li>
                <ul class="list-style-type-decimal-bracket">
                  <li>JONは、乙が支払うべき料金等の額及び支払期限を、乙に対して別途通知します。</li>
                  <li>乙は、前号の通知に従い、支払期限までに料金等を支払うものとします。</li>
                  <li>本サービスの料金等は、乙から、JON又はJONの指定する者に対して、直接、支払われるものとします。</li>
                  <li>本サービスの料金等の支払いにかかる手数料は、乙の負担によるものとします。</li>
                </ul>
              </li>
            </ul>
            <p class="md-body-2">第5条（乙の環境構築と管理義務）</p>
            <ol class="list-style-type-decimal">
              <li>乙は、利用申込み時にJONに提供した所定の情報に変更があった場合は、遅滞なく本サービスのサイト上で変更するものとします。</li>
              <li>
                乙は、本サービスを通じて提供されるJONデータ（以下、「本データ」といいます。）及びアカウントを厳重に保管・管理するものとし、これらの漏洩や不正使用が生じないよう、コンピューター・ウィルスの感染の防止、不正アクセスや情報漏洩の防止等のセキュリティ対策を、自己の費用と責任において万全に講じるものとします。
              </li>
              <li>
                乙は、本データ又はアカウントが漏洩し又は不正に使用された場合、被害の拡大防止と復旧のための措置を直ちに講じるものとし、併せてJONにその旨を連絡するものとします。この場合、JONは強制的にパスワードを変更することがあります。パスワードを変更したときは、JONは乙にその旨を通知するものとします。
              </li>
              <li>本データ又はアカウントの漏洩や不正使用による損害賠償の義務については、JONの責に帰すべき事由が認められる場合のほかは、乙が全責任を負うものとします。</li>
              <li>
                乙は、乙及びユーザが本サービスにおいて入力、送受信した情報の全てについて、自己の責任において管理するものとします。JONは、乙及びユーザの承諾を得ることなく、当該情報を任意に把握し、バックアップできるものとしますが、保存する義務を負うものではありません。JONはいつでもこれらの情報を削除できるものとします。
              </li>
              <li>
                乙は、次の各号の場合を除き、ユーザ1人につき1個のアカウントを、当該ユーザの専用端末（メインとなるデスクトップ端末1台及びユーザを同じくするモバイル端末1台の範囲とします。）により使用させるものとし、複数のユーザ・端末で1個のアカウントを共用してはならないものとします。
                <ul class="list-style-type-decimal-bracket">
                  <li>実店舗窓口における顧客応対用のデスクトップ端末を、乙のネットワークを介さずに当該窓口において共用する場合（ただし端末が複数台ある場合はそれぞれ別のアカウントで使用されるものとします。）</li>
                  <li>金融機関の地域支店における共用端末を、乙のネットワークを介さずに当該支店において共用する場合（ただし端末が複数台ある場合はそれぞれ別のアカウントで使用されるものとします。）</li>
                  <li>JONとの特別の合意がある場合</li>
                </ul>
              </li>
              <li>
                乙は、ユーザが、本規約に準拠した利用をすることについて責任を負うものとします。
              </li>
            </ol>
            <p class="md-body-2">第6条（財産権の帰属と不可侵、品質に関する免責）</p>
            <ol class="list-style-type-decimal">
              <li>
                本データは、適法に入手した公的文書を原典資料として構築される地理空間情報データ（以下、「マスタ」といいます。）の部分的複製物又はマスタを利用した生成物です。JONは、マスタの製造元より本データに関する対外的な使用許諾権の付与を受け、その行使とともに本サービスを提供するものです。乙及びユーザは、マスタ及び本データに関する次枠内の注意事項を確認し、同意するものとします。
                <p class="block">
                  マスタは、独自のノウハウをもとに、相当の稼働とコストをかけて構築されるデータベースであり、その所有権及び著作権、著作者人格権、その他一切の工業所有権、無体財産権等の知的財産権は、製造元に独占的に帰属します。また、マスタはそれ自体が販売の対象となることはなく、マスタの部分的複製物やマスタを利用した生成物である情報データが一定の使用許諾又は制限とともに乙及びユーザに提供され、乙及びユーザは当該使用許諾又は制限の範囲で本データを使用できることとなります。乙は、ユーザがこの趣旨を逸脱した使用をしないよう、必要な措置を講ずるものとします。</p>
              </li>
              <li>
                本契約に基づくデータ提供によっても、本データに関する一切の権利（所有権、占有権、特許権、商標権、著作権その他一切の知的財産権を含むがこれらに限られない。）は乙及びユーザへ移転せず、また本契約の趣旨を超えた実施や使用を許諾されるものではありません。乙及びユーザは、本契約に基づく行為により、JONの事業利益を実質的に損なわないことを約束するものとします。
              </li>
              <li>
                本データはJONにおける現状有姿により提供します。JONはできる限り、正確で新鮮なデータとなるよう努力しておりますが、データの性質上、原典資料や現況との不整合を完全に無くすことは不可能です。したがってJONは、本データに関する鮮度、精度、網羅性等の品質条件について一切の保証をするものではありません。また、本データの品質に限界があることによって、直接又は間接に乙又はユーザ又は第三者に生じたいかなる損害についても、JONは一切の責任を負わないものとします。地理情報コンテンツの現状有姿性にご理解ください。その他、本データの品質に関しお気づきの点がございましたら、弊社担当営業までご連絡ください。
              </li>
              <li>
                本データは社会における利活用のため作成されたものであり、法的な証明のため作成されたものではありません。土地の位置、形状、地番、その他本データに含まれる情報に関する本データの裁判上の証拠能力及び証明力について、JONは一切の関与・保証を行わないものとします。
              </li>
            </ol>
            <p class="md-body-2">第7条（一般的承諾事項）</p>
            <ul class="list-style-type-none">
              <li>
                乙は、以下の点につき予め承諾したものとします。
                <ul class="list-style-type-decimal-bracket">
                  <li>JONは、本サービスの提供その他本契約の履行に関して、その一部をJONとの間に予め守秘義務契約を締結した第三者に委託することがあります。</li>
                  <li>
                    JON、又はJONとの間に守秘義務契約を締結した上で委託を受けた第三者は、乙について登録された個人情報を対象として、各種商品の紹介、キャンペーンのお知らせ（無料アカウントへの自動登録を含みます。）、アンケートへの協力等を目的として、DM、電子メール等を配信することがあります。但し、乙から当該配信の停止等の依頼があった場合はこのかぎりではありません。
                  </li>
                  <li>JONは、乙について登録された個人情報を、本人が識別不可能な処理を施した上で、統計的に公表することがあります。</li>
                  <li>JONは、本サービスがあらゆる時点において正常に動作することや、本データに第6条第3項の現状有姿性による瑕疵が存する場合にこれを修正することを保証しないものとします。</li>
                  <li>JONは、JONが必要と判断した場合、本サービスの利用に一定の制約（一定時間あたりのアクセス回数制限、アクセス時間の制限など）を設けることができるものとします。</li>
                  <li>
                    JONは、本サービスの特性上、乙又はユーザが本サービスを通じて一般財団法人民事法務協会の登記情報提供サービスより取得する登記情報（登記情報全部事項、所有者事項、公図等をいう。以下同じ。）のコピーを保有するものとします。
                    <p class="block">
                      JONの保有する登記情報は、公的情報で構成されるマスタDBへ登録され、他の行政文書や位置情報（位置、形状）との連携、情報の電子化（解析）、変化情報DB
                      によるメンテナンス性能の付与等が施されることで、参照性、活用性が高められます。これにより、各種検索機能やピンポイント更新、二重取得防止等を内容とする管理機能など、これまでにない様々な機能を提供可能となります。この目的のため、登記情報のコピーを保有します。なお、登記情報のマスタ
                      DB 登録においては、特定のお客様が取得したという情報は完全に切り離されます。また、お客様が取得した登記情報PDFを第三者へ提供するサービスは実施しておりません。</p>
                  </li>
                  <li>
                    本サービスに登録した登記情報提供サービスのIDは、本サービスの操作中は、本サービスのみで使用するものとします。本サービス以外で使用（登記情報提供サービスで直接使用することを含む）したことにより生じたいかなる損害についても、JONは一切の責任を負わないものとします。
                  </li>
                  <li>乙は本サービスにかかる利用ログの「成立の真正」を争わないものとします。</li>
                  <li>本サービス中、他の法人及び団体のサービスによって構成された部分の利用については、乙は、当該他の法人及び団体の定める規約及び利用方法等に従うものとします。</li>
                </ul>
              </li>
            </ul>
            <p class="md-body-2">第8条（本データの使用許諾範囲）</p>
            <ol class="list-style-type-decimal">
              <li>
                本データ（複製物、改変物、翻案物を含む。以下同じ。）の使用許諾範囲は、次の通りとなります。
                <ul class="list-style-type-decimal-bracket">
                  <li>WEBブラウザ・WEBアプリによる本サービス内での閲覧（キャッシュフォルダへの一時的保持を含む。）</li>
                  <li>
                    JONの事業に競合しないものとしてJONが認めた印刷使用（以下、許諾可能な印刷の例示です。）
                    <ol class="list-style-type-katakana">
                      <li>
                        乙の事業に属する個別的案件に関する内部文書への添付、掲載を目的とした印刷又はこれに準ずる電磁的記録（PDF、JPEG等。以下同じ。）の作成使用
                        <ul class="list-style-type-example">
                          <li>金融機関におけるローン審査に関する文書への添付、掲載（当該審査箇所に限る。）</li>
                          <li>電力会社における送配電に関する管理・調査伝票への添付、掲載（当該管理・調査にかかる電柱・支持物・家屋箇所に限る。）</li>
                        </ul>
                      </li>
                      <li>
                        申請文書、行政文書、契約文書への添付・編綴・掲載（当該個別案件箇所に限る。）
                        <ul class="list-style-type-example">
                          <li>行政に提出する各種申請書への添付・編綴・掲載（当該申請箇所に限る。）</li>
                          <li>行政内部の個別案件にかかる行政文書への添付・編綴・掲載（当該個別案件箇所に限る。）</li>
                          <li>不動産業、建設業における契約書への添付・編綴・掲載（当該契約箇所に限る。）</li>
                        </ul>
                      </li>
                      <li>
                        一時的消費的使用であることが明らかな印刷又はこれに準ずる電磁的記録の作成使用
                        <ul class="list-style-type-example">
                          <li>外回り営業への印刷物携行（少量に限る。）</li>
                          <li>一般客への交付・PDF送信（特定の一般客に対し少量に限る。）</li>
                        </ul>
                      </li>
                    </ol>
                  </li>
                </ul>
              </li>
              <li>
                乙及びユーザは、次の各号に該当する本データの使用を行ってはなりません。
                <ul class="list-style-type-decimal-bracket">
                  <li>前項において許諾されない本データの印刷、複製、保存その他の使用</li>
                  <li>本データの第三者への全部又は一部の譲渡、貸与、使用権設定、公衆送信（前項第2号により許諾された場合を除く。）</li>
                  <li>JONの事業利益を実質的に損なうこととなる本データの使用（以下、例示です。）
                    <ol class="list-style-type-katakana">
                      <li>本データを自己に権利が帰属するものとして取り扱うこと（本契約に基づく使用許諾範囲を除く。）</li>
                      <li>本データを原材料又は参考にして、販売用情報成果物の作成、修正、検査、更新、その他品質向上又は製造工程の効率化をすること</li>
                      <li>本データをJONの事業と実質的に競合する自己又は第三者の事業に使用すること</li>
                      <li>本データをもとにJONの顧客又は潜在顧客に対して商品サービスを提供すること</li>
                      <li>本データをもとにJONの事業と実質的に競合する事業を営む第三者に対して商品サービスを提供し、その他協力をすること</li>
                      <li>
                        本データの翻案（細かい部分を作り替えること）、改変（内容を変えて違うものにすること）、更新（本データに本データのもつ鮮度以降の新規生成差分データ（更新データ）を加え、古くなり意味消失したデータを削除するなどして、鮮度を向上すること）
                      </li>
                    </ol>
                  </li>
                </ul>
              </li>
            </ol>
            <p class="md-body-2">第9条（一般的禁止事項）</p>
            <ul class="list-style-type-none">
              <li>
                乙及びユーザは、以下の行為をしてはなりません。
                <ul class="list-style-type-decimal-bracket">
                  <li>違法な目的、公序良俗に反する目的その他、不当な目的で本サービスを利用すること</li>
                  <li>JONに無断で本契約上の地位を第三者に譲渡すること</li>
                  <li>本サービスを利用する際に必要となるアカウントを自ら公開したり、他者のアカウントを不正に使用したりする行為</li>
                  <li>本サービスに関連するプログラム等の改造、解析、派生物の作成、本サービスを再提供することと同視し得るような様態による利用</li>
                  <li>本サービスをロボット等による機械的な方法（AIを搭載した電子的仕組みを含む。）によって操作すること</li>
                  <li>本サービスの履行、運営を妨げるような行為</li>
                  <li>本サービスをJONの事業と実質的に競合する目的で利用すること</li>
                  <li>その他本データをもとに法令に違反し又は違反するおそれのある行為をすること</li>
                </ul>
              </li>
            </ul>
            <p class="md-body-2">第10条（本サービスの一時停止、制限）</p>
            <ol class="list-style-type-decimal">
              <li>JONは、次の各号に該当する場合には、本サービスを一時停止又は制限することがあります。
                <ul class="list-style-type-decimal-bracket">
                  <li>料金及びその他の債務について支払期限を経過してもなお支払われないとき</li>
                  <li>本契約の申込時に虚偽の事項を通知したことが判明したとき</li>
                  <li>乙又はユーザにおいてJONの業務遂行又はJONの電気通信設備に支障を及ぼし、又は及ぼすおそれのある行為が確認されたとき</li>
                  <li>乙又はユーザに許諾外使用又は禁止行為のおそれがあるとき</li>
                  <li>その他乙又はユーザにおいてJONが不適当と判断する行為が確認されたとき</li>
                  <li>天災事変その他の非常事態の発生により本サービスの提供が不可能又は困難なとき</li>
                  <li>保守、更新、工事を定期的、あるいは緊急に行うとき</li>
                  <li>電気通信事業者が電気通信サービスの提供を中断することにより本サービスの提供が不可能又は困難なとき</li>
                  <li>インターネットを通じた不正なアクセスにより本サービスの提供が不可能又は困難なとき</li>
                  <li>その他、本サービスの提供が不可能又は困難であることに相当の理由があるとき</li>
                </ul>
              </li>
              <li>
                前項の規定により本サービスを一時停止又は制限しようとするときは、その旨を事前に乙に通知するものとします。ただし、前項第 3 号、第 4 号、その他緊急やむを得ない場合はこの限りではありません。
              </li>
              <li>
                本条の規定により本サービスが一時停止又は制限されたことにより乙その他の第三者が損害を被った場合でも、JONは一切の責任を負わないものとします。また、本サービスが一時停止又は制限された場合でも、本サービスの料金は有効に発生し、契約期間も有効に経過するものとします。
              </li>
            </ol>
            <p class="md-body-2">第11条（解約、契約の変更）</p>
            <ol class="list-style-type-decimal">
              <li>本契約は、月初から月末までの1ヶ月を単位とする自動更新契約とします。月途中から契約を開始した場合も同様とします。</li>
              <li>
                乙は、JONが別途定める方法により、毎月末日正午までにJONに申し出をすることにより、当月末日をもって本契約を解約することができます。当該期間中に申し出をしない場合には、期間満了日の翌日より1ヶ月間更新されるものとし、その後の更新についても同様とします。
              </li>
              <li>JONは、3か月前までに乙に申し出ることで、本契約を解約できるものとします。</li>
              <li>JONは、3か月前までに乙に申し出ることで、本規約、本契約にかかる料金、本サービスの仕様、その他契約条件を変更できるものとします。</li>
              <li>JONは、前項の規定にかかわらず、次の各号に該当する変更については、直ちにその内容を適用できるものとします。
                <ul class="list-style-type-decimal-bracket">
                  <li>インターフェースデザイン等の軽微な仕様の変更</li>
                  <li>本サービスに含まれる機能の追加的変更</li>
                  <li>その他、猶予期間を設けなくとも乙にとって不利とはならないことが明らかな本規約等の変更</li>
                </ul>
              </li>
              <li>本サービスの一部追加、一部解約についても本条第1項、第2項を準用するものとします。</li>
            </ol>
            <p class="md-body-2">第12条（解除）</p>
            <ul class="list-style-type-none">
              <li>
                乙又はユーザが次の各号に該当する場合には、JONは何らの催告なく本契約を解除できるものとします。
                <ul class="list-style-type-decimal-bracket">
                  <li>利用申込内容に虚偽があった場合</li>
                  <li>手形又は小切手の不渡りを出したとき</li>
                  <li>破産手続き開始、会社更生手続開始、民事再生手続開始等の申立てをし、又は第三者に申し立てられたとき</li>
                  <li>競売の申立てを受けたとき</li>
                  <li>差押えを受けたとき</li>
                  <li>乙又はユーザが本規約に違反し、又は契約を継続し難いような行為に出た場合で、JONが相当の期間を定めて催告したにもかかわらず、当該違反を改めたり当該行為を止めたりしないとき</li>
                  <li>乙又はユーザがJONと実質的に競合する商品サービスを提供する立場にある法人、団体、個人であるとJONが判断したとき</li>
                  <li>第8条第2項、第9条に違反した場合</li>
                </ul>
              </li>
            </ul>
            <p class="md-body-2">第13条（法令遵守及び反社会的勢力の排除の宣言）</p>
            <ol class="list-style-type-decimal">
              <li>
                JON及び乙は、本規約の各条項の他、個人情報の保護に関する法律、著作権法、不正競争防止法、私的独占の禁止及び公正取引の確保に関する法律、その他の関係法令並びに監督官庁等の指示、指導を遵守するものとします。
              </li>
              <li>JON及び乙は、自ら又は自らの役員及び従業員が、現在、暴力団、暴力団員、暴力団員でなくなった時から5年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ、
                又は特殊知能暴力集団等、その他これに準ずる者(以下、これらを「暴力団員等」といいます。)に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。
                <ul class="list-style-type-decimal-bracket">
                  <li>暴力団員等が経営を支配していると認められる関係を有すること</li>
                  <li>暴力団員等が経営に実質的に関与していると認められる関係を有すること</li>
                  <li>自己、自社もしくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に暴力団員等を利用していると認められる関係を有すること。</li>
                  <li>暴力団員等に対して資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること</li>
                  <li>役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること</li>
                </ul>
              </li>
              <li>JON及び乙は、自ら又は第三者を利用して次の各号の一にでも該当する行為を行わないことを確約します。
                <ul class="list-style-type-decimal-bracket">
                  <li>暴力的な要求行為</li>
                  <li>法的な責任を超えた不当な要求行為</li>
                  <li>取引に関して脅迫的な言動をし、又は暴力を用いる行為</li>
                  <li>風説を流布し偽計を用い又は威力を用いて相手方の信用を毀損し、又は業務を妨害する行為</li>
                  <li>その他、前各号に準ずる行為</li>
                </ul>
              </li>
              <li>
                JON及び乙は、下請業者又は再委託先業者(数次にわたるときは、その全てを含みます。)の自ら又は役員及び従業員が第2項のいずれにも、現在、かつ、将来にわたっても該当しないことを表明し、自ら又は第三者をして第3項各号の一にでも該当する行為を行わせないことを確約します。
              </li>
              <li>
                JON及び乙は、下請業者又は再委託先業者(数次にわたるときは、その全てを含みます。)の自ら又は役員及び従業員が第2項のいずれかに該当し、もしくは第3項各号のいずれかに該当する行為をしたことが判明した場合には、ただちに当該業者との契約を解除し、又はその他必要な措置を採るものとします。
              </li>
              <li>
                JON及び乙は、相手方が次の各号の一に該当したときは、書面による通知をもって、JONと乙との間で締結した、及び今後締結する各契約の全部又は一部をただちに解除することができ、これによって被った損害の賠償を相手方に請求できるものとします。
                <ul class="list-style-type-decimal-bracket">
                  <li>第2項の規定に基づく表明、確約に関して違反していることが判明したとき</li>
                  <li>第3項各号の一に該当する行為を行ったとき</li>
                  <li>第5項に規定する契約の解除、又はその他必要な措置を採らなかったとき</li>
                </ul>
              </li>
            </ol>
            <p class="md-body-2">第14条（準拠法及び裁判管轄権）</p>
            <ol class="list-style-type-decimal">
              <li>本規約の準拠法は日本法とします。</li>
              <li>本サービスの利用に関し生じた疑義又は本規約に定めのない事項については、JONと乙との間で誠実に協議することによって解決するものとします。</li>
              <li>本規約に関する一切の紛争(裁判所の調停手続きを含む)は、JONの本店所在地を管轄する地方裁判所を専属的合意管轄裁判所とします。</li>
            </ol>
            <p class="md-body-2">第15条（個人情報の取り扱いについて）</p>
            <ul class="list-style-type-none">
              <li>本サービスにおける個人情報の取り扱いは、別途定めるプライバシーポリシーによるものとします。</li>
            </ul>

            <p class="md-body-1 md-layout md-alignment-center-right">
              制定：2020年2月12日<br/>
              改定：2022年6月28日
            </p>
            <p class="md-layout md-alignment-center-right">
              <img src="https://cdn.jon-api.com/shikaku-map/img/jon.png"/>
            </p>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-size-10"></div>
    </div>
  </main>
</template>

<script>
import CommonMixin from "@/mixins/commonMixin";

export default {
  name  : "Terms",
  mixins: [CommonMixin],
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.md-card {
  padding: 20px 30px;
}

.md-body-2 {
  margin-top: 0;
  margin-bottom: 0;
  font-weight: bold;
}

.md-card-content {
  font-size: 12px;
  line-height: 18px;
}

.list-style-type-none {
  list-style-type: none;
  margin-top: 0;
  margin-bottom: 0;
}

.list-style-type-decimal,
.list-style-type-decimal-bracket,
.list-style-type-katakana {
  .block {
    border: 1px solid gray;
    padding: 2px 4px;
  }
}

.list-style-type-decimal {
  list-style-type: decimal;
  margin-top: 0;
  margin-bottom: 0;
}

.list-style-type-decimal-bracket {
  list-style-type: none;

  li {
    counter-increment: cnt;
    margin-left: -0.5em;

    &::before {
      content: '(' counter(cnt) ')';
      display: inline-block;
      margin-left: -2em;
      width: 2em;
    }
  }
}

.list-style-type-katakana {
  list-style-type: none;

  li {
    &:nth-child(1):before {
      content: '(ア)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }

    &:nth-child(2):before {
      content: '(イ)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }

    &:nth-child(3):before {
      content: '(ウ)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }

    &:nth-child(4):before {
      content: '(エ)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }

    &:nth-child(5):before {
      content: '(オ)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }

    &:nth-child(6):before {
      content: '(カ)';
      display: inline-block;
      margin-left: -2.5em;
      width: 2.5em;
    }
  }

  .list-style-type-example {
    list-style-type: none;
    counter-reset: cnt;

    li {
      counter-increment: cnt;
      margin-left: -0.5em;

      &::before {
        content: '例' counter(cnt);
        display: inline-block;
        margin-left: -2em;
        width: 2em;
      }
    }
  }
}
</style>
